import { useTranslation } from 'react-i18next';

import Alert from '@mui/material/Alert';

const UnsavedDataAlert = () => {
  const { t } = useTranslation('common');

  return (
    <Alert
      sx={{
        background: 'none',
        padding: 0
      }}
      severity="warning"
    >
      {t('unsavedData')}
    </Alert>
  );
};

export default UnsavedDataAlert;
